/**
 * Magical: Text Expander & Autofill — snippets / autofill
 *
 * Declares one large WAR group (hundreds of files) matched to every origin with no
 * use_dynamic_url. Most script entries are build-hashed (chunk-mgcl-*.js) and rotate
 * per release, but the assets/ tree carries stable vendor-named files. The
 * iconNotification.png badge loads via <img> with no CORS grant, and the vendor-named
 * content-ui.css stylesheet corroborates from an independent path.
 *
 * Manifest verified against version 3.119.1.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'iibninhmiggehlcdolcilmhacighjamp';

export const magical: ExtensionDefinition = {
  id: ID,
  name: 'Magical: Text Expander & Autofill',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Hundreds of static WAR on every origin, no dynamic URL. The script chunks are ' +
    'build-hashed, so detection uses the stable assets/ icons and the content-ui stylesheet.',
  signals: [
    {
      id: 'war-icon-notification-png',
      kind: 'web-accessible-resource',
      description:
        'Load assets/ate/iconNotification.png via <img> — a stable vendor-named badge ' +
        'exposed to every origin; needs no CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'assets/ate/iconNotification.png'),
    },
    {
      id: 'war-icon-16-png',
      kind: 'web-accessible-resource',
      description:
        'Load assets/icon-16.png via <img> — a second stable icon, corroborating the ' +
        'identification without a CORS grant.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/icon-16.png'),
    },
    {
      id: 'war-content-ui-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-scripts/root-ui/content-ui/content-ui.css — a vendor-named ' +
        'stylesheet on a stable path, independent of the icon probes.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content-scripts/root-ui/content-ui/content-ui.css'),
    },
  ],
};
